/* eslint-disable max-lines */
/* eslint-disable sonarjs/cognitive-complexity */
import React, { useCallback, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Field, FormSection } from 'redux-form';
import debounce from 'lodash/debounce';
import TextBox from '@tcp/core/src/components/common/atoms/TextBox';
import SelectBox from '@tcp/core/src/components/common/atoms/Select';
import Row from '@tcp/core/src/components/common/atoms/Row';
import Col from '@tcp/core/src/components/common/atoms/Col';
import { AutoCompleteComponent } from '@tcp/core/src/components/common/atoms/AutoSuggest/AutoCompleteComponent';
import { AutoCompleteComponentGmaps } from '@tcp/core/src/components/common/atoms/AutoSuggest/AutoCompleteComponentGmaps';
import RenderPerf from '@tcp/web/src/components/common/molecules/RenderPerf';
import { getModuleXContent } from '@tcp/web/src/components/features/content/HeaderNew/molecules/CountrySelector/container/CountrySelector.actions';
import {
  SHIPPING_FORM_VISIBLE,
  SPC_CUSTOM_DIMENSION_GROUP,
  SPC_TIMER,
} from '@tcp/core/src/constants/rum.constants';
import { formatPhoneNumber } from '@tcp/core/src/utils/formValidation/phoneNumber';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import CheckoutLabels from '@tcp/core/src/utils/labels/cnc/checkout.labels';
import {
  GLOBAL_GENERIC_LABELS,
  GlobalGenericLabels,
  lblPhoneNumber,
} from '@tcp/core/src/utils/labels/globalGeneric.labels';
import GlobalAddEditAddressLabels, {
  GLOBAL_ADD_EDIT_ADDRESS_LABELS,
} from '@tcp/core/src/utils/labels/globalAddEditAddress.labels';
import { getCountriesMap } from '@tcp/web/src/components/features/content/HeaderNew/molecules/CountrySelector/container/CountrySelector.selectors';
import DynamicInjectCountrySelector from '@tcp/web/src/components/features/content/HeaderNew/molecules/CountrySelector/container/DynamicInjectCountrySelector';
import { trimMaxCharacters, isCanada } from '../../../../../../utils';
import {
  CAcountriesStatesTable,
  countriesOptionsMap,
  UScountriesStatesTable,
} from '../../../../../common/organisms/AddressForm/CountriesAndStates.constants';
import AddressAutoCompleteDefaultComponent from './AddressAutoCompleteDefault';
import {
  POBOX_DEBOUNCE_DELAY,
  SHIPPING_FIELD_ADDRESS_LINE_1,
  SHIPPING_FIELD_ADDRESS_LINE_2,
} from '../../container/Shipping/Shipping.constants';
import SMSFormFields from '../../../../../common/molecules/SMSFormFields';
import EmailSignUpCheckBox from '../../../Checkout/molecules/EmailSignUpCheckBox';
import { getIsGuestUser } from '../../../../../../utils/utils';
import { getCountryListData } from '../../../../../../reduxStore/actions';
import { renderInternationalBillingAddressError } from '../../../Checkout/organisms/BillingPaymentForm/views/BillingPaymentForm.view.util';
import ReduxFormIntlTelInput from '../../../../../common/atoms/CustomPhoneNumber/views/CustomPhoneNumberInput';

function getAddressFormFieldClass(section) {
  return !section?.isFormExpanded ? 'hidden-field' : '';
}

const MEDIUM_SPACING = 'elem-mb-MED';

// eslint-disable-next-line complexity
function ShippingAddressForm(props) {
  const {
    isBillingForm,
    section,
    addressFormLabels,
    formSection,
    shippingFormInput,
    mapboxSwitch,
    mapboxAutocompleteTypesParam,
    handlePlaceSelected,
    handlePlaceSelectedGmaps,
    fillFormManually,
    handleSave,
    changeZipCode,
    changeShipmentMethods,
    zipCodeABTestEnabled,
    showCountrySelection,
    changeAddress,
    showIndicatorIcon,
    checkoutBillingAddressFormValue,
    smsSignUpLabels,
    isUsSite,
    isSnJ,
    isGymboree,
    isChildrenPalace,
    emailSignUpLabels,
    emailSignUpFlags,
    emailSignUpCaRichText,
    initialValues,
    isLoginV2FlowEnabled,
    savedEmail,
    emailFailSafe,
    venmoStatus,
    countriesMap,
    loadCountryListData,
    loadCountryModuleXData,
    isBillingInternationalAddressEnabled,
    isInternationalPhoneNumberEnabled,
    dispatchFormFieldChange,
    className,
    defaultPhoneNumber,
    defaultCountryCode,
    isPlccIC,
    setPhoneCountryAction,
    orderTrackingEnhancementEnabled,
  } = props;
  const checkoutLabels = getLabelFromCopyOrFromTranslation('checkout', CheckoutLabels);
  useEffect(() => {
    (async function () {
      await DynamicInjectCountrySelector();
      if (!countriesMap.length) {
        loadCountryListData();
      }
      const referredContent = getDynamicLabelValues('global.countrySelector.referred');
      let content;
      if (referredContent && Array.isArray(referredContent)) {
        content = referredContent.find(
          (label) => label.name === 'lbl_global_country_selector_note'
        );
      }
      loadCountryModuleXData(content && content.contentId);
    })();
  }, []);
  const globalGenericLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_GENERIC_LABELS,
    GlobalGenericLabels
  );

  const globalAddEditAddressLabels = getLabelFromCopyOrFromTranslation(
    GLOBAL_ADD_EDIT_ADDRESS_LABELS,
    GlobalAddEditAddressLabels
  );
  const isSMSChecked = getIsGuestUser()
    ? initialValues?.smsSignUp?.sendOrderUpdate
    : shippingFormInput?.smsSignUp?.sendOrderUpdate;
  const { state: selectedStateId } = shippingFormInput;
  const isCA = isCanada();
  const defaultOptionComponent = AddressAutoCompleteDefaultComponent({
    fillFormManually,
    addressFormLabels,
  });
  const hiddenFieldClass = getAddressFormFieldClass(section);

  let stateType = 'CA';
  if (isCA) {
    if (checkoutBillingAddressFormValue?.country === 'US') {
      stateType = 'US';
    }
  } else {
    stateType = 'US';
    if (checkoutBillingAddressFormValue?.country === 'CA') {
      stateType = 'CA';
    }
  }
  const internationalBillingAddress =
    checkoutBillingAddressFormValue?.country !== 'US' &&
    checkoutBillingAddressFormValue?.country !== 'CA' &&
    checkoutBillingAddressFormValue?.country !== undefined &&
    checkoutBillingAddressFormValue?.country !== '' &&
    isBillingForm &&
    isBillingInternationalAddressEnabled;

  const suppressWarning =
    (checkoutBillingAddressFormValue?.country === 'US' && !isCanada()) ||
    (checkoutBillingAddressFormValue?.country === 'CA' && isCanada());
  const showInternationalBillingAddressError =
    !suppressWarning &&
    isBillingForm &&
    isBillingInternationalAddressEnabled &&
    section?.isFormExpanded &&
    checkoutBillingAddressFormValue?.country !== undefined &&
    checkoutBillingAddressFormValue?.country !== '';
  let component = TextBox;
  if (!zipCodeABTestEnabled && !internationalBillingAddress) {
    if (mapboxSwitch) {
      component = AutoCompleteComponent;
    } else {
      component = AutoCompleteComponentGmaps;
    }
  }

  const countryType = stateType === 'CA' ? 'ca' : 'us';

  const handleAddressLineChange = useCallback(
    debounce(
      (event, target) => changeAddress && changeAddress(event, target),
      POBOX_DEBOUNCE_DELAY
    ),
    []
  );
  const addressLine1Label =
    section?.id === 'paymentSection'
      ? renderLabel(
          checkoutLabels.billing?.lbl_billing_billingAddress,
          'lbl_billing_billingAddress'
        )
      : renderLabel(
          globalAddEditAddressLabels?.lbl_addEditAddress_shippingAddress,
          'lbl_addEditAddress_shippingAddress'
        );

  const customWidthForState = isCanada() ? 4 : 3;
  const customWidthForCity = isCanada() ? 5 : 6;

  const renderEmailSignUp = () => {
    const isEmailSignedUp = initialValues?.emailSignUp?.emailSignUp;
    return (
      <Row fullBleed className={`${hiddenFieldClass}`}>
        <FormSection name="emailSignUp">
          <EmailSignUpCheckBox
            labels={emailSignUpLabels}
            fieldName="emailSignUp"
            bottomSeparator
            emailSignUpFlags={emailSignUpFlags}
            emailSignUpCaRichText={emailSignUpCaRichText}
            isSnJ={isSnJ}
            isUsSite={isUsSite}
            isGymboree={isGymboree}
            isChildrenPalace={isChildrenPalace}
            spc
            isCheckedTCP={isEmailSignedUp?.emailSignUpTCP}
            isCheckedGYM={isEmailSignedUp?.emailSignUpGYM}
            isLoginV2FlowEnabled={isLoginV2FlowEnabled}
          />
        </FormSection>
      </Row>
    );
  };

  const maxLengthForCAandUS = stateType === 'CA' ? 7 : 5;
  const maxLengthForZipcode = internationalBillingAddress ? 10 : maxLengthForCAandUS;
  return (
    <form onSubmit={handleSave}>
      <Row fullBleed>
        <Col
          ignoreGutter={{ small: true, medium: true, large: true }}
          colSize={{ small: 6, medium: 8, large: 12 }}
        >
          <Field
            placeholder={renderLabel(globalGenericLabels.lbl_firstName, 'lbl_firstName')}
            name="firstName"
            id={`${formSection}.firstName`}
            component={TextBox}
            showIndicatorIcon={showIndicatorIcon}
            dataLocator="first-name-field"
            className="elem-mb-MED elem-mt-XS"
            enableSuccessCheck={false}
            spc
            isRequired
            customReduxAction
          />
        </Col>
      </Row>
      <Row fullBleed>
        <Col colSize={{ small: 6, medium: 8, large: 12 }}>
          <Field
            placeholder={renderLabel(globalGenericLabels.lbl_lastName, 'lbl_lastName')}
            name="lastName"
            id={`${formSection}.lastName`}
            component={TextBox}
            showIndicatorIcon={showIndicatorIcon}
            dataLocator="last-name-field"
            className="elem-mb-MED"
            enableSuccessCheck={false}
            spc
            isRequired
            customReduxAction
          />
        </Col>
      </Row>
      <Row fullBleed>
        <Col colSize={{ small: 6, medium: 8, large: 12 }} className="autoComp elem-mb-MED">
          <Field
            id="addressLine1"
            placeholder={renderLabel(
              globalAddEditAddressLabels.lbl_addEdit_findYourAddress,
              'lbl_addEdit_findYourAddress'
            )}
            label={addressLine1Label}
            component={component}
            name="addressLine1"
            onPlaceSelected={mapboxSwitch ? handlePlaceSelected : handlePlaceSelectedGmaps}
            componentRestrictions={Object.assign({}, { country: [countryType] })}
            dataLocator="address-line-1-field"
            className="field mapbox"
            maxLength="30"
            normalize={trimMaxCharacters(30)}
            apiFields="address_components"
            enableSuccessCheck={false}
            mapboxAutocompleteTypesParam={mapboxAutocompleteTypesParam}
            defaultOptionComponent={defaultOptionComponent}
            onChange={(e) => handleAddressLineChange(e, SHIPPING_FIELD_ADDRESS_LINE_1)}
            spc
            autoSuggest
            isRequired
            customReduxAction
          />
        </Col>
      </Row>
      <Row fullBleed>
        <Col
          colSize={{ small: 6, medium: 8, large: 12 }}
          className={`elem-mb-MED ${hiddenFieldClass}`}
        >
          <Field
            placeholder={renderLabel(
              globalAddEditAddressLabels.lbl_addEditAddress_addressLine2,
              'lbl_addEditAddress_addressLine2'
            )}
            name="addressLine2"
            id={`${formSection}.addressLine2`}
            maxLength={30}
            normalize={trimMaxCharacters(30)}
            component={TextBox}
            showIndicatorIcon={showIndicatorIcon}
            dataLocator="address-line-2-field"
            enableSuccessCheck={false}
            onChange={(e) => handleAddressLineChange(e, SHIPPING_FIELD_ADDRESS_LINE_2)}
            spc
            customReduxAction
          />
        </Col>
      </Row>
      <Row fullBleed>
        <Col
          colSize={{ small: 6, medium: 3, large: customWidthForState }}
          className={`elem-mb-MED ${hiddenFieldClass}`}
        >
          <Field
            placeholder={
              stateType === 'CA'
                ? renderLabel(
                    globalAddEditAddressLabels.lbl_addEditAddress_postalCode,
                    'lbl_addEditAddress_postalCode'
                  )
                : renderLabel(globalGenericLabels.lbl_zipCode, 'lbl_zipCode')
            }
            name={internationalBillingAddress ? 'zipCodeInternational' : 'zipCode'}
            id={
              internationalBillingAddress
                ? `${formSection}.zipCodeInternational`
                : `${formSection}.zipCode`
            }
            maxLength={maxLengthForZipcode}
            component={TextBox}
            showIndicatorIcon={showIndicatorIcon}
            dataLocator="zip-code-field"
            enableSuccessCheck={false}
            onChangeHandler={changeZipCode}
            spc
            isRequired
            customReduxAction
          />
        </Col>

        <Col
          colSize={{ small: 3, medium: 3, large: customWidthForCity }}
          ignoreNthRule
          className={`${isBillingForm ? MEDIUM_SPACING : ''} ${hiddenFieldClass}`}
        >
          <Field
            placeholder={renderLabel(
              globalAddEditAddressLabels.lbl_addEditAddress_city,
              'lbl_addEditAddress_city'
            )}
            name="city"
            id={`${formSection}.city`}
            component={TextBox}
            showIndicatorIcon={showIndicatorIcon}
            dataLocator="city-field"
            enableSuccessCheck={false}
            spc
            isRequired
            customReduxAction
          />
        </Col>
        {!internationalBillingAddress ? (
          <Col
            colSize={{ small: 3, medium: 2, large: 3 }}
            className={`${isBillingForm ? MEDIUM_SPACING : ''} ${hiddenFieldClass}`}
          >
            <Field
              id={`${formSection}.state`}
              placeholder={
                stateType === 'CA'
                  ? renderLabel(
                      globalAddEditAddressLabels.lbl_addEditAddress_province,
                      'lbl_addEditAddress_province'
                    )
                  : renderLabel(
                      globalAddEditAddressLabels.lbl_addEditAddress_state,
                      'lbl_addEditAddress_state'
                    )
              }
              title={
                stateType === 'CA'
                  ? renderLabel(
                      globalAddEditAddressLabels.lbl_addEditAddress_province,
                      'lbl_addEditAddress_province'
                    )
                  : renderLabel(
                      globalAddEditAddressLabels.lbl_addEditAddress_state,
                      'lbl_addEditAddress_state'
                    )
              }
              name="state"
              value={selectedStateId}
              component={SelectBox}
              showIndicatorIcon={showIndicatorIcon}
              options={stateType === 'CA' ? CAcountriesStatesTable : UScountriesStatesTable}
              dataLocator="state-field"
              className="address-field"
              enableSuccessCheck={false}
              onChange={changeShipmentMethods}
              spc
            />
          </Col>
        ) : (
          <Col
            colSize={{ small: 3, medium: 2, large: 3 }}
            ignoreNthRule
            className={`${isBillingForm ? MEDIUM_SPACING : ''} ${hiddenFieldClass}`}
          >
            <Field
              placeholder={renderLabel(
                globalAddEditAddressLabels.lbl_addEditAddress_state,
                'lbl_addEditAddress_state'
              )}
              name="state"
              id={`${formSection}.state`}
              component={TextBox}
              showIndicatorIcon={showIndicatorIcon}
              className="address-field"
              enableSuccessCheck={false}
              spc
            />
          </Col>
        )}
      </Row>
      {isLoginV2FlowEnabled && (
        <>
          <Row fullBleed>
            <Col
              colSize={{ small: 6, medium: 8, large: 12 }}
              className={`elem-mb-MED ${hiddenFieldClass}`}
            >
              {!isInternationalPhoneNumberEnabled ? (
                <Field
                  placeholder={renderLabel(globalGenericLabels.lbl_phone_no, 'lbl_phone_no')}
                  name="phoneNumber"
                  id={`${formSection}.phoneNumber`}
                  component={TextBox}
                  dataLocator="addnewaddress-phnumber"
                  type="tel"
                  enableSuccessCheck={false}
                  normalize={formatPhoneNumber}
                  autocomplete="tel"
                  spc
                  isRequired
                  showIndicatorIcon={showIndicatorIcon}
                />
              ) : (
                <Field
                  name="phoneNumber"
                  component={ReduxFormIntlTelInput}
                  className={`${className} elem-pb-XS `}
                  id={`${formSection}.phoneNumber`}
                  dataLocator="phone-number-field"
                  dispatchFormFieldChange={dispatchFormFieldChange}
                  defaultPhoneNumber={defaultPhoneNumber}
                  defaultCountryCode={defaultCountryCode}
                  labelValue={globalGenericLabels[lblPhoneNumber]}
                  isPlccIC={isPlccIC}
                  setPhoneCountryAction={setPhoneCountryAction}
                />
              )}
            </Col>
          </Row>
          {(!savedEmail || emailFailSafe || venmoStatus) && (
            <Row fullBleed>
              <Col
                colSize={{ small: 6, medium: 8, large: 12 }}
                className={`elem-mb-MED ${hiddenFieldClass}`}
              >
                <Field
                  placeholder={renderLabel(
                    globalAddEditAddressLabels.lbl_addEditAddress_email,
                    'lbl_addEditAddress_email'
                  )}
                  name="emailAddress"
                  id={`${formSection}.emailAddress`}
                  component={TextBox}
                  dataLocator="email-address-field"
                  enableSuccessCheck={false}
                  autocomplete="email"
                  spc
                  isRequired
                  showIndicatorIcon={showIndicatorIcon}
                  customReduxAction
                />
              </Col>
            </Row>
          )}
          {isUsSite && !orderTrackingEnhancementEnabled && (
            <Row fullBleed className={`${hiddenFieldClass}`}>
              <FormSection name="smsSignUp" className={`${hiddenFieldClass}`}>
                <SMSFormFields
                  labels={smsSignUpLabels}
                  colSize={{ small: 6, medium: 8, large: 12 }}
                  showDefaultCheckbox={false}
                  formName="ShippingForm"
                  formSection="smsSignUp"
                  variation="secondary"
                  isOrderUpdateChecked
                  smsOrderUpdatesRichText={smsSignUpLabels && smsSignUpLabels.smsSignupText}
                  spc
                  isLoginV2FlowEnabled={isLoginV2FlowEnabled}
                  isSMSChecked={isSMSChecked}
                />
              </FormSection>
            </Row>
          )}
          {!isUsSite && renderEmailSignUp()}
        </>
      )}
      <Row fullBleed>
        <Col
          colSize={{ small: 6, medium: 8, large: 12 }}
          className={`${showCountrySelection ? '' : 'hidden-field'} ${hiddenFieldClass}`}
        >
          {isBillingForm && (
            <Field
              placeholder={renderLabel(
                globalAddEditAddressLabels.lbl_addEditAddress_country,
                'lbl_addEditAddress_country'
              )}
              title={renderLabel(
                globalAddEditAddressLabels.lbl_addEditAddress_country,
                'lbl_addEditAddress_country'
              )}
              name="country"
              id={`${formSection}.country`}
              component={SelectBox}
              showIndicatorIcon={showIndicatorIcon}
              options={
                isBillingForm && isBillingInternationalAddressEnabled
                  ? countriesMap
                  : countriesOptionsMap
              }
              dataLocator="country-field"
              enableSuccessCheck={false}
              spc
            />
          )}
          {!isBillingForm && (
            <Field
              placeholder={renderLabel(
                globalAddEditAddressLabels.lbl_addEditAddress_country,
                'lbl_addEditAddress_country'
              )}
              title={renderLabel(
                globalAddEditAddressLabels.lbl_addEditAddress_country,
                'lbl_addEditAddress_country'
              )}
              name="country"
              id={`${formSection}.country`}
              component={SelectBox}
              showIndicatorIcon={showIndicatorIcon}
              options={countriesOptionsMap}
              dataLocator="country-field"
              enableSuccessCheck={false}
              value={isCanada() ? 'CA' : 'US'}
              disabled={true}
              spc
            />
          )}
        </Col>
      </Row>
      <RenderPerf.Measure
        name={SHIPPING_FORM_VISIBLE}
        start={`${SHIPPING_FORM_VISIBLE}:start`}
        timerName={SPC_TIMER}
        cdGroup={SPC_CUSTOM_DIMENSION_GROUP}
      />
      {showInternationalBillingAddressError && (
        <div className="errorWrapper">
          {renderInternationalBillingAddressError(checkoutBillingAddressFormValue)}
        </div>
      )}
    </form>
  );
}

ShippingAddressForm.propTypes = {
  formSection: PropTypes.string,
  shippingFormInput: PropTypes.shape({}).isRequired,
  mapboxSwitch: PropTypes.bool,
  mapboxAutocompleteTypesParam: PropTypes.string,
  handlePlaceSelected: PropTypes.func.isRequired,
  handlePlaceSelectedGmaps: PropTypes.func.isRequired,
  fillFormManually: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  changeZipCode: PropTypes.func.isRequired,
  changeShipmentMethods: PropTypes.func.isRequired,
  zipCodeABTestEnabled: PropTypes.bool,
  section: PropTypes.shape({}).isRequired,
  showCountrySelection: PropTypes.bool,
  changeAddress: PropTypes.func.isRequired,
  isBillingForm: PropTypes.bool,
  showIndicatorIcon: PropTypes.bool,
};

ShippingAddressForm.defaultProps = {
  formSection: '',
  mapboxSwitch: false,
  mapboxAutocompleteTypesParam: '',
  zipCodeABTestEnabled: false,
  showCountrySelection: false,
  isBillingForm: false,
  showIndicatorIcon: true,
};

export const mapDispatchToProps = (dispatch) => {
  return {
    loadCountryModuleXData: (payload) => {
      dispatch(getModuleXContent(payload));
    },
    loadCountryListData: () => {
      dispatch(getCountryListData());
    },
  };
};

const mapStateToProps = (state) => {
  return {
    countriesMap: getCountriesMap(state),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ShippingAddressForm);
